/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_AInputs */



/**
* | output |
* | --- |
* | "Program A" |
*
* @param {Subtitle_Export_Program_AInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_a = /** @type {((inputs?: Subtitle_Export_Program_AInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_AInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Programme A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Programm A")
	if (locale === "it") return /** @type {LocalizedString} */ ("Programma A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Программа А")
	if (locale === "es") return /** @type {LocalizedString} */ ("Programa A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("程序 A")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プログラムA")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम ए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Programa A")
	return /** @type {LocalizedString} */ ("Program A")
});